import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';
import { IChat } from '../interfaces';

export interface ChatTag {
  id: string;
  name: string;
  type: 'chat';
  color: string;
}

export interface TagPermissions {
  can_manage: boolean;
}

export interface TagPayload {
  name: string;
  type: 'chat';
  color: string;
}

@Injectable({ providedIn: 'root' })
export class TagService {
  constructor(private readonly http: HttpClient) {}

  getTags() {
    return this.http.get<any>(`${environment.baseURL}/tags`).pipe(map(res => res.data as ChatTag[]));
  }

  getPermissions() {
    return this.http.get<any>(`${environment.baseURL}/tags/permissions`).pipe(map(res => res.data as TagPermissions));
  }

  createTag(payload: TagPayload) {
    return this.http.post<any>(`${environment.baseURL}/tags`, payload).pipe(map(res => res.data as ChatTag));
  }

  updateTag(tagId: string, payload: Partial<TagPayload>) {
    return this.http.put<any>(`${environment.baseURL}/tags/${tagId}`, payload).pipe(map(res => res.data as ChatTag));
  }

  deleteTag(tagId: string) {
    return this.http.delete<any>(`${environment.baseURL}/tags/${tagId}`).pipe(map(res => res.data));
  }

  setChatTags(chatId: string, tagIds: string[]) {
    return this.http.put<any>(`${environment.baseURL}/chats/${chatId}/tags`, { tag_ids: tagIds })
      .pipe(map(res => res.data as IChat));
  }
}
